module.exports = __webpack_public_path__ + "img/コンピュータのしくみI_4_12_1.40d6a544.jpeg";